import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgLearning = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M4.19 16h9.24q.235 0 .399-.18a.57.57 0 0 0 .171-.417.6.6 0 0 0-.114-.359.6.6 0 0 0-.285-.216 1.2 1.2 0 0 1-.65-.612 1.48 1.48 0 0 1-.093-.926q.1-.515.543-.986a3.4 3.4 0 0 0 .4-.522q.198-.314.199-.874V2.344Q14 1.18 13.444.59 12.894 0 11.788 0H4.212Q3.105 0 2.549.59 2 1.172 2 2.344v11.349q0 1.15.55 1.725Q3.1 16 4.19 16m.064-1.202q-.542 0-.827-.291-.279-.291-.278-.822 0-.5.314-.798.32-.307.856-.306h7.32a1.3 1.3 0 0 0 .25-.023q-.25.582-.222 1.165.035.59.321 1.075zm-.214-3.352a.38.38 0 0 1-.285-.127.43.43 0 0 1-.121-.306v-9.43q0-.18.121-.299a.382.382 0 0 1 .57 0 .4.4 0 0 1 .13.299v9.43q0 .18-.13.306a.38.38 0 0 1-.285.127"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLearning);
export default ForwardRef;
